import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { POLICIES } from "@/data/brand";

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy)
    return (
      <div className="jm-container py-24 text-center">
        <h1 className="font-display text-4xl text-navy">Page not found</h1>
        <Link to="/" className="text-brick font-bold mt-4 inline-block">Back home</Link>
      </div>
    );

  return (
    <div data-testid="policy-page" className="jm-container py-16 max-w-3xl">
      <Helmet>
        <title>{`${policy.title} | JohnnyMart`}</title>
        <meta name="description" content={policy.intro} />
        <link rel="canonical" href={`https://johnnymart.net/policies/${slug}`} />
      </Helmet>
      <p className="uppercase tracking-[0.2em] text-brick font-bold text-sm">Store Policy</p>
      <h1 className="font-display text-4xl sm:text-5xl text-navy mt-2">{policy.title}</h1>
      <p className="mt-4 text-ink/75 leading-relaxed">{policy.intro}</p>

      <div className="mt-8 space-y-6">
        {policy.sections.map((s) => (
          <div key={s.heading} className="bg-white rounded-lg border border-navy/15 p-6">
            <h2 className="font-display text-2xl text-navy">{s.heading}</h2>
            <p className="mt-2 text-ink/80 leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <p className="mt-8 text-sm text-ink/50">
        Questions about this policy? Email <a href="mailto:ShopJohnnyMart@yahoo.com" className="text-brick font-semibold">ShopJohnnyMart@yahoo.com</a> and we'll be happy to help.
      </p>
    </div>
  );
}
